import mitt from 'mitt';
import { Enum_AutoStationElement, Enum_ForecastElement, Enum_ForecastMode } from 'erayic-com-pack/utils/attribute/Element';
import { Doc_config } from '@/components/DocumentsEditingPanel/config';
import { Enum_Environment } from '@/views/Main/MainBean';

export type Events = {
  /** 时间改变 */
  TimeChange: Date,
  /** 改变工作环境 */
  ChangeWorkEnvironment: Enum_Environment,
  /** 关闭所有活动面板 */
  CloseAllActivePanel: undefined,
  /** 请求数据监测 */
  RequestMonitoring: {
    /** 实况类型 */
    FactsType: "自动站" | "CLDAS",
    /** 实况要素 */
    FactsElement: Enum_AutoStationElement,
    /** 预报要素 */
    ForecastElement: Enum_ForecastElement,
    /** 预报模式在该要素对应的id */
    ForecastMode: Enum_ForecastMode,
    /** 监测时间点 */
    Timing?: Date
  },
  /** 项目初始化 */
  ProjectInitialize: undefined,
  /** 主题改变 */
  ThemeChange: "default" | "white",
  /** 开关昌江高程数据 */
  CJGC: boolean,
  /** 开关遮罩图层 */
  MaskLayer: boolean,
  /** 打开pageOffice */
  InitDocumentEditPanel: Doc_config,
  /** 开启了选点 */
  ChooseMapboxPointsEvent: undefined
};

export default mitt<Events>();